import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {getParam} from '../utils/utils';
import {formatText, truncate} from '../utils/utils';
import {cloneObject} from '../utils/utils';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import {getInterface, addMethodToInterface, editMethod, getMethod, deleteMethod} from '../utils/utilsInterface';

import D3Graphviz from "../components/D3Graphviz";
import ViewMethod from "../components/ViewMethod";
import ViewMetadata from "../components/ViewMetadata";
import ViewInterface from "../components/ViewInterface";

import FormPathElement from "../components/FormPathElement";
import FormMethodParameter from "../components/FormMethodParameter";
import FormMethodResponse from "../components/FormMethodResponse";


import Revision from "../components/Revision";
import ListRevisions from "../components/ListRevisions";

import { Plus, Trash, ArrowUp, ArrowDown } from 'react-bootstrap-icons';


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';
import SelectSerialization from "../components/SelectSerialization";

class Method extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};
        this.viz = null;
        this.vizEngine = "dot";


        this.handleChange = this.handleChange.bind(this);
        this.handleControls = this.handleControls.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.refRevision = React.createRef();
        this.loadedRevisions = this.loadedRevisions.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadInterface(id){

        this.setState({renderState: "loading"});

        const onLoad = (Interface) => {
            this.FallBackNavigation = `/interface/${Interface._id}`;

            let StateChange = {
                Interface: Interface,
                idInterface: Interface._id,
                renderState: "loaded"
            };

            if (this.state.mode === 'new'){
                StateChange.FormData = {
                    status: 'in use'
                };
            }

            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id === Interface.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "delete":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Methods to this Interface";
                        break;
                }
            }

            this.setState(StateChange);
        };

        const onFail = (e) => {
            this.setState({
                renderState: "failed",
                errorMessage: e.message
            });
        };

        getInterface(this.dsd, id, onLoad, onFail);
        
    };

    loadMethod(id){

        this.setState({renderState: "loading"});

        const onLoad = (Method) => {
            this.FallBackNavigation = `/interface/${Method.Interface._id}`;

            let StateChange = {
                Interface: Method.Interface,
                idInterface: Method.Interface._id,
                Method: Method,
                FormData: Method,
                renderState: "loaded"
            };

            if (Method.Interface){
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsInterface(Method.Interface._id);
                }
            }


            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id === Method.Interface.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "delete":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Methods to this Interface";
                        break;
                }
            }

            this.setState(StateChange);
        };

        const onFail = (e) => {
            this.setState({
                renderState: "failed",
                errorMessage: e.message
            });
        };

        getMethod(this.dsd, id, onLoad, onFail);
        
    };


    setup(){

        let StateChange = {
            mode: "view",
            toggle : 0,
            idMethod: null,
            idInterface: null,
            Interface: null,
            Method: null,
            renderState: null,
            FormData: {},
            OfferEdit:false,
            Controls: {},
            countRevisions: null
        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idMethod = getParam('id', this.props);
        StateChange.idInterface = getParam('idInterface', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idInterface){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Interface not specified when adding a Method"
                }
                break;
            default:
                if (StateChange.idInterface){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Interface should not be specified for an existing Method"
                }
                if (!StateChange.idMethod){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Method not specified"
                }
                break;
        }

        if (StateChange.mode == "new"){
            if (StateChange.idInterface){
                this.FallBackNavigation = `/interface/${StateChange.idInterface}`;
            }        
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);

        // Direct orchestration
        if (StateChange.idInterface && StateChange.mode === 'new'){
            this.loadInterface(StateChange.idInterface);
        }
        if (StateChange.idMethod){
            this.loadMethod(StateChange.idMethod);
        }
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleControls(event){

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        Controls[FormFieldName] = FormFieldValue;        
        this.setState({"Controls": Controls});

        return;

    }


    handleSubmit(event) {

        // Define callbacks at top
        const onAdd = (idMethod) => {
            this.props.navigation(`/method/${idMethod}`);
        };

        const onUpdate = (Method) => {

            // Update revision history
            this.refRevision.current.update();
            this.props.navigation(`/method/${this.state.idMethod}`);
        };

        const onDelete = () => {
            this.props.navigation(this.FallBackNavigation);
        };

        const onError = (error) => {
            this.setState({
                renderState: error.status,
                errorMessage: error.errorMessage
            });
        };

        window.scrollTo(0, 0);

        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case "edit":
                    case "delete":
                        this.props.navigation(`/method/${this.state.idMethod}`);
                        break;
                    case "new":
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;

            case 'btnDelete':
                deleteMethod(this.dsd, this.state.idInterface, this.state.idMethod, onDelete, onError);
                break;

            case 'btnSave':
            default:
                this.setState({
                    renderState: "updating"
                });
        
                switch (this.state.mode){
                    case 'new':
                        addMethodToInterface(this.dsd, this.state.idInterface, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editMethod(this.dsd, this.state.idMethod, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'serialization':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/serialization/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'structure':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/structure/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'method':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/method/${partsVizNodeId[1]}`);
                    }
                    break;
            }
        }

        event.preventDefault();

    };


    loadedRevisions(count) {

        let StateChange = {};

        StateChange.countRevisions = 0;
        if (count){
            StateChange.countRevisions = count;
        }

        this.setState(StateChange);


    };


    visualise(){
    
        if (!this.state.Method){
            return null;
        }


        try {

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.viz.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Method</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Select label='Action' name='action'  onChange={this.handleChange} value={this.state.FormData.action}>
                                        {
                                            this.dsd.model.config.MethodActions.map(
                                                (action, pos) => 
                                                    {
                                                        return(
                                                            <option key={pos} value={action}>{action}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    {(this.state.FormData.action == "post" || this.state.FormData.action == "put") &&
                                        <fieldset>
                                            <legend>Request</legend>
                                            <SelectSerialization name="idSerialization" label="Serialization" idInterface={this.state.idInterface} onChange={this.handleChange} value={this.state.FormData.idSerialization}/>
                                        </fieldset>
                                    }

                                    {this.FormPath()}
                                    {this.FormParameters()}
                                    {this.FormResponses()}



                                    <Revision ref={this.refRevision}  idAbout={this.state.idMethod}/>
                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'delete':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Method</PD.Heading>

                        <PD.Button name="btnDelete" onClick={this.handleSubmit} type="warning" value="confirm delete?" />
                        <PD.Button name="btnCancel" onClick={this.handleSubmit} type="warning" value="cancel" />
                        <ViewMethod Method={this.state.Method}/>

                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        let countParameters = 0;
                        if (this.state.Method.Parameters){
                            countParameters = this.state.Method.Parameters.length;
                        }

                        let countResponses = 0;
                        if (this.state.Method.Responses){
                            countResponses = this.state.Method.Responses.length;
                        }

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Method:{this.state.Method.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                            <PD.Button onClick={this.handleMode} type="submit" value="delete" />
                                    </span>
                                }

                                <ViewMethod Method={this.state.Method}/>
                                <br/>

                                <PD.Tabs>

                                    <div label={`Parameters(${countParameters})`}>
    
                                        {isArray(this.state.Method.Parameters) &&
                                            <PD.Table className="list">
                                                <PD.Thead>
                                                    <PD.Tr>
                                                        <PD.Th>Name</PD.Th>
                                                        <PD.Th>Where</PD.Th>
                                                        <PD.Th>Occurs</PD.Th>
                                                        <PD.Th>Required?</PD.Th>
                                                    </PD.Tr>
                                                </PD.Thead>
    
                                                <PD.Tbody>
                                                    {
                                                        this.state.Method.Parameters.map(
                                                            (MethodParameter, pos) => 
                                                            {
                                                                return (
                                                                    <PD.Tr key={pos}>
                                                                        <PD.Td>
                                                                            {MethodParameter.Parameter &&
                                                                                <PD.PdNavLink to={"/parameter/" + MethodParameter.Parameter._id} >
                                                                                    {MethodParameter.Parameter.name}
                                                                                </PD.PdNavLink>
                                                                            }                                                                        
                                                                       </PD.Td>
                                                                            
                                                                        <PD.Td>
                                                                            {MethodParameter.where &&
                                                                                MethodParameter.where}
                                                                        </PD.Td>

                                                                        <PD.Td>
                                                                            {MethodParameter.occurs &&
                                                                                MethodParameter.occurs}
                                                                        </PD.Td>
    
                                                                        <PD.Td>
                                                                            {MethodParameter.required &&
                                                                                MethodParameter.required}
                                                                        </PD.Td>
    
                                                                    </PD.Tr>
                                                                )
                                                            }
                                                        )
                                                    }
                                                </PD.Tbody>
                                            </PD.Table>
                                        }
    
                                    </div>

                                    <div label={`Responses(${countResponses})`}>
    
                                        {isArray(this.state.Method.Responses) &&
                                            <PD.Table className="list">
                                                <PD.Thead>
                                                    <PD.Tr>
                                                        <PD.Th>Status Code</PD.Th>
                                                        <PD.Th>Status Description</PD.Th>
                                                        <PD.Th>Serialization</PD.Th>
                                                        <PD.Th>Occurs</PD.Th>
                                                    </PD.Tr>
                                                </PD.Thead>

                                                <PD.Tbody>
                                                    {
                                                        this.state.Method.Responses.map(
                                                            (MethodResponse, pos) => 
                                                            {
                                                                return (
                                                                    <PD.Tr key={pos}>

                                                                        <PD.Td>
                                                                            {MethodResponse.statusCode &&
                                                                                MethodResponse.statusCode}
                                                                        </PD.Td>

                                                                        <PD.Td>
                                                                            <PD.MdPresent>{truncate(MethodResponse.description, 400)}</PD.MdPresent>
                                                                        </PD.Td>

                                                                        <PD.Td>
                                                                            {MethodResponse.Serialization &&
                                                                                <PD.PdNavLink to={"/serialization/" + MethodResponse.Serialization._id} >
                                                                                    {MethodResponse.Serialization.name}
                                                                                </PD.PdNavLink>
                                                                            }                                                                        
                                                                        </PD.Td>

                                                                        <PD.Td>
                                                                            {MethodResponse.occurs &&
                                                                                MethodResponse.occurs}
                                                                        </PD.Td>
    
                                                                    </PD.Tr>
                                                                )
                                                            }
                                                        )
                                                    }
                                                </PD.Tbody>
                                            </PD.Table>
                                        }

                                    </div>

                                    <div label='Interface'>
                                        <ViewInterface Interface={this.state.Interface}/>
                                    </div>


                                    <div label={<span>Revisions({this.state.countRevisions === null ? <Buffering/> : this.state.countRevisions})</span>} data-forcerender="true">
                                        <ListRevisions OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idMethod}} onLoad={this.loadedRevisions}/>
                                    </div>

                                    <div label='Developer'>
                                        <table>
                                            
                                            {this.viz &&
                                                <tr>
                                                    <th style={{verticalAlign:"top"}}>dot</th>
                                                    <td><pre>{JSON.stringify(this.state.Method,null,4)}</pre></td>
                                                </tr>
                                            }

                                            {this.state.Method &&
                                                <tr>
                                                    <th style={{verticalAlign:"top"}}>DSD</th>
                                                    <td><pre>
                                                        {JSON.stringify(this.state.Method,null,4)}{"\n\n"}
                                                    </pre></td>
                                                </tr>
                                            }


                                        </table>
                                    </div>

                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };

    showError(){

        return(
            <>
                {this.state.errorMessage &&
                    <p>{this.state.errorMessage}</p>
                }

                {this.state.invalidFields &&
                    Object.keys(this.state.invalidFields).map(
                    (field, pos) => 
                        {
                            let error = this.state.invalidFields[field].error;
                            return <p key={pos}>{field}:{error}</p>
                        }
                    )
                }
            </>
        )

    }


    FormPath(){

        let seqNext = 1;
        if (this.state.FormData.Path){
            seqNext = this.state.FormData.Path.length + 1;
        }
        return (
            <fieldset>
                <legend>Path</legend>
                {this.state.FormData.Path &&
                    this.state.FormData.Path.map(
                        (Element, posElement) => 
                        {
                            let seq = posElement+1;
                            return(
                                this.FormPathElement('edit', seq, Element)
                            )
                        }
                    )
                }
                {this.FormPathElement('new', seqNext)}
            </fieldset>
        );

    }

    FormPathElement(mode, seq, Element = {}){

        let onAdd = function(){
           let FormData = {...this.state.FormData};
           FormData.Path = [...(FormData.Path || []), {}];
           this.setState({"FormData": FormData});

        }
        onAdd = onAdd.bind(this);

        let onRemove = function(seq){
        
            let FormData = {...this.state.FormData};
            FormData.Path = [...(FormData.Path || [])];
            FormData.Path.splice(seq-1, 1);
      
            this.setState({"FormData": FormData});
    
        }
        onRemove = onRemove.bind(this);
        
        let onUpdate = function(seq, Element){                    
            let FormData = {...this.state.FormData};
            FormData.Path = [...(FormData.Path || [])];
            FormData.Path[seq-1] = Element;

            this.setState({"FormData": FormData});
        }
        onUpdate = onUpdate.bind(this);


        let onMoveUp = null;
        let onMoveDown = null;


        if (this.state.FormData.Path){
            if (seq < this.state.FormData.Path.length){
                onMoveDown = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.Path = [...(FormData.Path || [])];
                    
                    // Swap with next item
                    [FormData.Path[seq-1], FormData.Path[seq]] =
                    [FormData.Path[seq], FormData.Path[seq-1]];
                    
                    this.setState({"FormData": FormData});

                    event.preventDefault();
                    return;

                }
                onMoveDown = onMoveDown.bind(this);

            }


            if ((seq > 1) && (seq<=this.state.FormData.Path.length)){
                onMoveUp = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.Path = [...(FormData.Path || [])];
                    
                    // Swap with previous item
                    [FormData.Path[seq-2], FormData.Path[seq-1]] =
                    [FormData.Path[seq-1], FormData.Path[seq-2]];
                    
                    this.setState({"FormData": FormData});

                    event.preventDefault();
                    return;
        
                }
                onMoveUp = onMoveUp.bind(this);
            }
        }

        return(
            <div>
                <FormPathElement 
                    key={seq.toString()} 
                    mode={mode} 
                    onAdd={onAdd}
                    onRemove={onRemove}
                    onUpdate={onUpdate}
                    {...(onMoveUp && { onMoveUp:onMoveUp})}
                    {...(onMoveDown && { onMoveDown:onMoveDown})}
                    Element={Element} 
                    idInterface={this.state.idInterface}
                    seq={seq}
                />
            </div>
        )
    }
    


    FormParameters(){

        let seqNext = 1;
        if (this.state.FormData.Parameters){
            seqNext = this.state.FormData.Parameters.length + 1;
        }
        return (
            <fieldset>
                <legend>Parameters</legend>
                {this.state.FormData.Parameters &&
                    this.state.FormData.Parameters.map(
                        (MethodParameter, pos) => 
                        {
                            let seq = pos+1;
                            return(
                                this.FormMethodParameter('edit', seq, MethodParameter)
                            )
                        }
                    )
                }
                {this.FormMethodParameter('new', seqNext)}
            </fieldset>
        );

    }

    FormMethodParameter(mode, seq, MethodParameter = {}){

        let onAdd = function(){
            let FormData = {...this.state.FormData};
            FormData.Parameters = [...(FormData.Parameters || []), {}];
            this.setState({"FormData": FormData});
        }
        onAdd = onAdd.bind(this);

        let onRemove = function(seq){
        
            let FormData = {...this.state.FormData};
            FormData.Parameters = [...(FormData.Parameters || [])];
            FormData.Parameters.splice(seq-1, 1);
      
            this.setState({"FormData": FormData});
    
        }
        onRemove = onRemove.bind(this);
        
        let onUpdate = function(seq, MethodParameter){
                    
            let FormData = {...this.state.FormData};
            FormData.Parameters = [...(FormData.Parameters || [])];
            FormData.Parameters[seq-1] = MethodParameter;

            this.setState({"FormData": FormData});
    
        }
        onUpdate = onUpdate.bind(this);


        let onMoveUp = null;
        let onMoveDown = null;

        if (this.state.FormData.Parameters){
            if (seq < this.state.FormData.Parameters.length){
                onMoveDown = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.Parameters = [...(FormData.Parameters || [])];
                    
                    // Swap with next item
                    [FormData.Parameters[seq-1], FormData.Parameters[seq]] =
                    [FormData.Parameters[seq], FormData.Parameters[seq-1]];
                    
                    this.setState({"FormData": FormData});

                    event.preventDefault();
                    return;

                }
                onMoveDown = onMoveDown.bind(this);

            }

            if ((seq > 1) && (seq<=this.state.FormData.Parameters.length)){
                onMoveUp = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.Parameters = [...(FormData.Parameters || [])];
                    
                    // Swap with previous item
                    [FormData.Parameters[seq-2], FormData.Parameters[seq-1]] =
                    [FormData.Parameters[seq-1], FormData.Parameters[seq-2]];
                    
                    this.setState({"FormData": FormData});

                    event.preventDefault();
                    return;
        
                }
                onMoveUp = onMoveUp.bind(this);
            }
        }

        return(
            <div>
                <FormMethodParameter 
                    key={seq.toString()} 
                    mode={mode} 
                    onAdd={onAdd}
                    onRemove={onRemove}
                    onUpdate={onUpdate}
                    {...(onMoveUp && { onMoveUp:onMoveUp})}
                    {...(onMoveDown && { onMoveDown:onMoveDown})}
                    MethodParameter={MethodParameter} 
                    idInterface={this.state.idInterface}
                    seq={seq}
                />
            </div>
        )
    }



    FormResponses(){

        let seqNext = 1;
        if (this.state.FormData.Responses){
            seqNext = this.state.FormData.Responses.length + 1;
        }
        return (
            <fieldset>
                <legend>Responses</legend>
                {this.state.FormData.Responses &&
                    this.state.FormData.Responses.map(
                        (MethodResponse, pos) => 
                        {
                            let seq = pos+1;
                            return(
                                this.FormMethodResponse('edit', seq, MethodResponse)
                            )
                        }
                    )
                }
                {this.FormMethodResponse('new', seqNext)}
            </fieldset>
        );

    }

    FormMethodResponse(mode, seq, MethodResponse = {}){

        let onAdd = function(){
            let FormData = {...this.state.FormData};
            FormData.Responses = [...(FormData.Responses || []), {}];
            
            this.setState({"FormData": FormData});
        }
        onAdd = onAdd.bind(this);
        
        let onRemove = function(seq){
        
            let FormData = {...this.state.FormData};
            FormData.Responses = [...(FormData.Responses || [])];
            FormData.Responses.splice(seq-1, 1);
            
            this.setState({"FormData": FormData});
    
        }
        onRemove = onRemove.bind(this);
        
        let onUpdate = function(seq, MethodResponse){
                    
            let FormData = {...this.state.FormData};
            FormData.Responses = [...(FormData.Responses || [])];
            FormData.Responses[seq-1] = MethodResponse;

            this.setState({"FormData": FormData});
    
        }
        onUpdate = onUpdate.bind(this);


        let onMoveUp = null;
        let onMoveDown = null;

        if (this.state.FormData.Responses){
            if (seq < this.state.FormData.Responses.length){
                onMoveDown = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.Responses = [...(FormData.Responses || [])];
                    
                    // Swap with next item
                    [FormData.Responses[seq-1], FormData.Responses[seq]] =
                    [FormData.Responses[seq], FormData.Responses[seq-1]];
                    
                    this.setState({"FormData": FormData});

                    event.preventDefault();
                    return;

                }
                onMoveDown = onMoveDown.bind(this);

            }


            if ((seq > 1) && (seq<=this.state.FormData.Responses.length)){
                onMoveUp = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.Responses = [...(FormData.Responses || [])];
                    
                    // Swap with previous item
                    [FormData.Responses[seq-2], FormData.Responses[seq-1]] =
                    [FormData.Responses[seq-1], FormData.Responses[seq-2]];
                    
                    this.setState({"FormData": FormData});

                    event.preventDefault();
                    return;
        
                }
                onMoveUp = onMoveUp.bind(this);
            }
        }

        return(
            <div>
                <FormMethodResponse 
                    key={seq.toString()} 
                    mode={mode} 
                    onAdd={onAdd}
                    onRemove={onRemove}
                    onUpdate={onUpdate}
                    {...(onMoveUp && { onMoveUp:onMoveUp})}
                    {...(onMoveDown && { onMoveDown:onMoveDown})}
                    MethodResponse={MethodResponse} 
                    idInterface={this.state.idInterface}
                    seq={seq}
                />
            </div>
        )
    }


};

// Wrap and export
export default function Method_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Method {...props} navigation={navigation} location={location} params={params} />;
  }